﻿function FullscreenComponent() {
	// find components w/ class name or data attribute
	let fsComps = document.querySelectorAll('.fullscreen');

	// return if none
	if (fsComps == null) {
		return;
	}

	const triggerTabResize = new CustomEvent('resizeTableauDash');

	// attach event listeners
	fsComps.forEach(function (el) {
		let expandButton = el.querySelector('a.btn[href="#open"]');

		expandButton.addEventListener('click', function (e) {
			e.preventDefault();

			let state = el.dataset.expanded;
			let icon = el.querySelector('.icon');

			if (state == 'closed') {
				el.classList.add('fullscreen--active');
				el.dataset.expanded = 'open';

				icon.classList.add('shrink');
				icon.classList.remove('expand');

				ToggleNoScroll(true);
				expandButton.dispatchEvent(triggerTabResize);
			} else if (state == 'open') {
				el.classList.remove('fullscreen--active');
				el.dataset.expanded = 'closed';

				icon.classList.add('expand');
				icon.classList.remove('shrink');

				ToggleNoScroll(false);
				expandButton.dispatchEvent(triggerTabResize);
			}
		});
	});
}

export default FullscreenComponent();

function ToggleNoScroll(on) {
	let body = document.querySelector('body');

	if (on) {
		body.classList.add('noscroll');
	}
	else {
		body.classList.remove('noscroll');
	}
}